import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../../css/others/Table.css";
import Pagination from "../../Reusablecomponents/Pagination";
import { FiDownload, FiFileText, FiImage, FiFile } from "react-icons/fi";
import { AiOutlineFilePdf, AiOutlineFileExcel, AiOutlineFileWord } from "react-icons/ai";
import { BiSpreadsheet } from "react-icons/bi";
import { FaEye } from "react-icons/fa";
import { apiCall } from "../../main/ApiCall";
import { FunctionViewChecklistDetails, FunctionViewAttachment, FunctionViewResponse, TypeEnum } from '../../interFaces/interfaces';
import EncryptionUtils from "../../main/encryptionUtils";
const extensionToIcon: Record<string, JSX.Element> = {
  pdf: <AiOutlineFilePdf className="file-icon pdf" />,
  png: <FiImage className="file-icon image" />,
  jpg: <FiImage className="file-icon image" />,
  jpeg: <FiImage className="file-icon image" />,
  txt: <FiFileText className="file-icon text" />,
  csv: <BiSpreadsheet className="file-icon csv" />,
  xlsx: <AiOutlineFileExcel className="file-icon excel" />,
  docx: <AiOutlineFileWord className="file-icon word" />,
  default: <FiFile className="file-icon default" />,
};
const AuditorViewFunctionCheckListDetails: React.FC = () => {
  const { campaignId, functionId } = useParams();
  const [details, setDetails] = useState<FunctionViewChecklistDetails | null>(null);
  const [, setLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [selectedAttachments, setSelectedAttachments] = useState<FunctionViewAttachment[]>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const userInfo = EncryptionUtils.get<any>("userInfo", null);
  const [typeEnums, setTypeEnums] = useState<TypeEnum[]>([]);
  const roleName = EncryptionUtils.get("roleName");
  const userId = userInfo?.id;
  const createdBy = userInfo?.email
  useEffect(() => {
    const fetchChecklistDetails = async () => {
      if (!campaignId || !functionId) return;
      setLoading(true);
      try {
        const requestBody = { campaignId, functionId, createdBy, ...(roleName === "Auditor" && { auditorId: userId }) };
        const response = await apiCall("post", "/api/function/audit/campaign/auditor/questions", requestBody, { page: currentPage - 1, size: itemsPerPage });
        const checklistData: FunctionViewChecklistDetails = {
          content: response?.responses?.map((item: FunctionViewResponse) => ({ functionQuestionId: item.functionQuestionId, functionAreaName: item.functionAreaName || "Empty", evidenceRequired: item.evidenceRequired || "Empty", isoClauseReference: item.isoClauseReference || "Empty", annexAControlReference: item.annexAControlReference || "Empty", questionText: item.questionText || "Empty", typeOfFindings: item.typeOfFindings || "Empty", findings: item.findings || "Empty", attachments: item.attachments || [] })) || [],
          totalElements: response?.totalElements || 0,
          totalPages: response?.totalPages || 0,
        };
        setDetails(checklistData);
        setTotalElements(checklistData.totalElements);
        setTotalPages(checklistData.totalPages);
      } catch (error) {
        console.error("Error fetching checklist details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchChecklistDetails();
  }, [campaignId, functionId, userId, roleName, createdBy, currentPage, itemsPerPage]);
  const openModal = (attachments: FunctionViewAttachment[]) => {
    setSelectedAttachments(attachments);
    setIsModalOpen(true);
  };
  const closeModal = () => { setSelectedAttachments([]); setIsModalOpen(false) };
  useEffect(() => {
    const fetchTypeEnums = async () => {
      try {
        const response = await apiCall("get", "/api/enums/TypeEnum");
        setTypeEnums(response);
      } catch (error) {
        console.error("Error fetching TypeEnum values:", error);
      }
    };
    fetchTypeEnums();
  }, []);
  const getTypeDescription = (typeValue: string) => {
    const typeEnum = typeEnums.find(enumItem => enumItem.value === typeValue);
    return typeEnum ? typeEnum.description : typeValue;
  };
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Function Audit Details</h2>
      </div>
      <div className="table-container">
        <div className="table">
          <table className="main-table">
            <thead>
              <tr>
                <th>S.No.</th><th className="header-width">Function Area</th><th className="header-width">Evidence Required</th><th className="header-width">ISO Clause Ref</th><th className="header-width">Annex A Control Ref</th><th className="header-width">Question</th><th className="header-width">Type of Findings</th><th className="header-width">Findings</th><th className="header-width">Attachments</th>
              </tr>
            </thead>
            <tbody>
              {details?.content && details.content.length > 0 ? (
                details.content.map((item, index) => (
                  <tr key={item.functionQuestionId}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{item.functionAreaName || "Empty"}</td>
                    <td>{item.evidenceRequired || "Empty"}</td>
                    <td>{item.isoClauseReference || "Empty"}</td>
                    <td>{item.annexAControlReference || "Empty"}</td>
                    <td>{item.questionText || "Empty"}</td>
                    <td>{getTypeDescription(item.typeOfFindings ?? "") || "Empty"}</td>
                    <td>{item.findings || "Empty"}</td>
                    <td>
                      {item.attachments.length > 0 ? (
                        <button onClick={() => openModal(item.attachments)} className="action-button"><FaEye /></button>
                      ) : (
                        <p>No attachments</p>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={9} className="no-data">No responses available for this checklist</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Attachments</h2>
            <div className="attachment-container">
              {selectedAttachments.map((attachment, index) => {
                const fileName = attachment.fileKey || "unknown";
                const fileExtension = fileName.split(".").pop()?.toLowerCase() || "default";
                const icon = extensionToIcon[fileExtension] || extensionToIcon.default;
                return (
                  <div key={index} className="attachment-item">{icon}
                    <a href={attachment.presignedUrl} target="_blank" rel="noopener noreferrer" className="attachment-link">{fileName}</a>
                    <a href={attachment.presignedUrl} download={fileName} className="download-icon"><FiDownload /></a>
                  </div>
                );
              })}
              <button className="close" onClick={closeModal}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default AuditorViewFunctionCheckListDetails;